import { ApplicationConfig, mergeApplicationConfig } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { commonConfig } from './app.config.common';

export const appConfig: ApplicationConfig = mergeApplicationConfig(
    commonConfig,
    {
        providers: [provideClientHydration(), provideAnimations()],
    }
);
